import * as Dialog from "@radix-ui/react-dialog";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import styled, { css } from "styled-components";
import { getThemeMedia, getThemeSpace } from "../helpers";
// Dropdown
export const Root = styled.div `
	&[data-reference='A'][data-reference-menu='A'] {
		pointer-events: none;

		button div div i {
			display: none;
		}
	}
`;
export const Trigger = styled(DropdownMenu.Trigger) `
	margin: 0;
	padding: 0;

	${({ isMenuButton }) => isMenuButton &&
    css `
			padding: 0;
		`}
`;
export const Portal = styled(DropdownMenu.Portal) ``;
export const Items = styled(DropdownMenu.Item) `
	&:hover {
		outline: none;
	}
`;
export const Content = styled(DropdownMenu.Content) `
	@keyframes downEntrance {
		0% {
			opacity: 0;
			transform: scaleY(0);
			transform-origin: top;
		}

		100% {
			opacity: 1;
			transform: scaleY(1);
			transform-origin: top;
		}
	}

	@keyframes upExit {
		0% {
			opacity: 1;
			transform: scaleY(1);
			transform-origin: top;
		}

		100% {
			opacity: 0;
			transform: scaleY(0);
			transform-origin: top;
		}
	}

	background-color: var(--surface-white);

	width: 100vw;
	height: 100vh;

	&[data-state='open'] {
		animation: downEntrance 0.5s ease 0s 1 normal forwards;
	}

	&[data-state='false'] {
		animation: upExit 1s ease 0s 1 normal forwards;
	}

	> span {
		display: none;
	}

	@media screen {
		@media (min-width: ${getThemeMedia("medium")}) {
			border-radius: ${({ radiusFullDesktop }) => (radiusFullDesktop ? "8px" : "0px 0px 8px 8px")};

			box-shadow: 0px 8px 12px #00000029;
			width: auto;

			${({ desktopFull }) => desktopFull &&
    css `
					border-radius: 0;
					box-shadow: 0;
					width: 100vw;
				`}

			height: auto;
		}
	}
`;
// MODAL
export const ContentModal = styled(Dialog.Content) `
	@keyframes downEntranceModal {
		0% {
			opacity: 0;
			transform: rotateX(-100deg);
			transform-origin: top;
		}

		100% {
			opacity: 1;
			transform: rotateX(0deg);
			transform-origin: top;
		}
	}

	position: fixed;
	top: 0;
	left: 0;

	width: 100vw;
	height: fit-content;
	height: 100vh;

	transform: translate(-50%, -50%);

	animation: downEntranceModal 500ms ease-in-out 0s 1 normal forwards;

	@supports not (overflow-anchor: initial) {
		animation-duration: 0s;
	}
`;
export const ContentWrapperModal = styled(Dialog.Content) `
	margin: 0 auto;

	display: flex;
	flex-direction: column;
	align-items: center;

	background-color: var(--surface-white);

	height: 100%;
	width: 100%;

	text-align: center;

	pointer-events: visible !important;
`;
export const Close = styled(Dialog.Close) `
	padding: ${getThemeSpace("8")} ${getThemeSpace("16")};

	position: absolute;
	right: 0;
	top: 0;

	cursor: pointer;
`;
//# sourceMappingURL=styles.js.map